import { useSyncExternalStore } from 'react';
import { getNightSnapshot, setGlobalNight, subscribeNight, type NightSnapshot } from './nightMode';

export function useNightMode(): NightSnapshot & {
    setGlobal: (on: boolean) => void;
} {
    const snapshot = useSyncExternalStore(subscribeNight, getNightSnapshot, getNightSnapshot);
    return { ...snapshot, setGlobal: setGlobalNight };
}

/** Empty while night mode is on. Pages and portaled popups share the night palette. */
export function useCanvasClass(chrome = false): string {
    const { canvasReady } = useNightMode();
    if (chrome || !canvasReady) return '';
    return 'light-canvas';
}
